/**
 * localStorage helpers for infection trend chart filters
 * (scoped per user + program + optional site scope + optional instance).
 */

export const INFECTION_TREND_FILTER_KEY_PREFIX = 'infection-trend-filters:';

/**
 * @param {string|number} userId
 * @param {string|null|undefined} programCode
 * @param {string|null|undefined} siteScope
 * @param {string|null|undefined} instanceScope
 * @returns {string}
 */
export function buildInfectionTrendFilterStorageKey(
    userId,
    programCode,
    siteScope = null,
    instanceScope = null
) {
    const programKey =
        programCode && String(programCode).trim()
            ? String(programCode).trim()
            : 'all';
    const baseKey = `${INFECTION_TREND_FILTER_KEY_PREFIX}${userId}:${programKey}`;
    const normalizedSiteScope =
        siteScope && String(siteScope).trim() ? String(siteScope).trim() : null;
    const normalizedInstanceScope =
        instanceScope && String(instanceScope).trim()
            ? String(instanceScope).trim()
            : null;

    let key = normalizedSiteScope
        ? `${baseKey}:site:${normalizedSiteScope}`
        : baseKey;

    if (normalizedInstanceScope) {
        key = `${key}:instance:${normalizedInstanceScope}`;
    }

    return key;
}

/**
 * @param {string|number} userId
 * @param {string|null|undefined} programCode
 * @param {string|null|undefined} siteScope
 * @param {string|null|undefined} instanceScope
 * @returns {object|null}
 */
export function loadInfectionTrendFilterPayload(
    userId,
    programCode,
    siteScope = null,
    instanceScope = null
) {
    if (userId == null) return null;
    const key = buildInfectionTrendFilterStorageKey(
        userId,
        programCode,
        siteScope,
        instanceScope
    );
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}

/**
 * @param {string|number} userId
 * @param {string|null|undefined} programCode
 * @param {object} payload
 * @param {string|null|undefined} siteScope
 * @param {string|null|undefined} instanceScope
 */
export function saveInfectionTrendFilterPayload(
    userId,
    programCode,
    payload,
    siteScope = null,
    instanceScope = null
) {
    if (userId == null || !payload || typeof payload !== 'object') return;
    const key = buildInfectionTrendFilterStorageKey(
        userId,
        programCode,
        siteScope,
        instanceScope
    );
    try {
        localStorage.setItem(key, JSON.stringify(payload));
    } catch {
        // Quota or private mode — ignore
    }
}
